import { graphql } from '@/gql';
import { type WillCallRidesQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchWillCallRideRecords = async ({ pagination, phoneNumber, pickupDate, status }: WillCallRidesQueryVariables) => {
  const variables = {
    pagination,
    phoneNumber: phoneNumber?.trim() || undefined,
    pickupDate,
    status,
  };

  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables,
    query: graphql(`
      query WillCallRides(
        $pagination: PaginationInputType
        $phoneNumber: String
        $pickupDate: String
        $status: [WillCallRideStatusFilter!]
      ) {
        willCallRides(pagination: $pagination, phoneNumber: $phoneNumber, pickupDate: $pickupDate, status: $status) {
          count
          rows {
            id
            completedAt
            canceledAt
            updatedAt
            callerId
            firstPickup
            lastRideAt
            executedAt
            riderPhone
            rideName
            rideType
            rideMultiple
            pickupTime
            pickupDate
            timeZone
            streetAddress1
            city1
            state1
            zip1
            lat1
            long1
            locationName1
            streetAddress2
            city2
            state2
            zip2
            lat2
            long2
            locationName2
            noteToDriver
            cancellationReason
            partnerId
            createdAt
            nextPickupTimeString
            callerName
            callerPhoneNumber
          }
        }
      }
    `),
  });
  return response.data.willCallRides;
};
